export enum ContactPreference {    
    Phone = 1,
    Email = 2
}